import { useSelector } from 'react-redux';
import { RootState } from '@/store';

export const useAuth = () => {
  const { user, loading } = useSelector((state: RootState) => state.auth);

  const hasRole = (requiredRoles: string[]) => {
    if (!user) return false;
    return requiredRoles.some(role => user.roles.includes(role));
  };

  return {
    user,
    isAuthenticated: !!user,
    loading,
    hasRole
  };
};